/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
  PostApiV1TutoraiDocumentsDocumentidImportPathParams,
  PostApiV1TutoraiDocumentsDocumentidImport400,
  PostApiV1TutoraiDocumentsDocumentidImport401,
  PostApiV1TutoraiDocumentsDocumentidImport404,
  PostApiV1TutoraiDocumentsDocumentidImport500,
} from "../../types/tutorAIDocumentosController/PostApiV1TutoraiDocumentsDocumentidImport.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1TutoraiDocumentsDocumentidImport } from "../../clients/tutorAIDocumentosController/postApiV1TutoraiDocumentsDocumentidImport.ts";

export const postApiV1TutoraiDocumentsDocumentidImportMutationKey = () =>
  [{ url: "/api/v1/tutorai/documents/:documentId/import" }] as const;

export type PostApiV1TutoraiDocumentsDocumentidImportMutationKey = ReturnType<
  typeof postApiV1TutoraiDocumentsDocumentidImportMutationKey
>;

export function postApiV1TutoraiDocumentsDocumentidImportMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postApiV1TutoraiDocumentsDocumentidImportMutationKey();
  return mutationOptions<
    PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsDocumentidImport400
      | PostApiV1TutoraiDocumentsDocumentidImport401
      | PostApiV1TutoraiDocumentsDocumentidImport404
      | PostApiV1TutoraiDocumentsDocumentidImport500
    >,
    {
      documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ documentId }) => {
      return postApiV1TutoraiDocumentsDocumentidImport(documentId, config);
    },
  });
}

/**
 * @description Realiza chunking, gera embeddings e indexa no TutorAI. **(Requer Authorization para autenticação)**
 * @summary Importar documento (chunking + embedding) (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents/:documentId/import}
 */
export function usePostApiV1TutoraiDocumentsDocumentidImport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
      ResponseErrorConfig<
        | PostApiV1TutoraiDocumentsDocumentidImport400
        | PostApiV1TutoraiDocumentsDocumentidImport401
        | PostApiV1TutoraiDocumentsDocumentidImport404
        | PostApiV1TutoraiDocumentsDocumentidImport500
      >,
      {
        documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1TutoraiDocumentsDocumentidImportMutationKey();

  const baseOptions = postApiV1TutoraiDocumentsDocumentidImportMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsDocumentidImport400
      | PostApiV1TutoraiDocumentsDocumentidImport401
      | PostApiV1TutoraiDocumentsDocumentidImport404
      | PostApiV1TutoraiDocumentsDocumentidImport500
    >,
    {
      documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"];
    },
    TContext
  >;

  return useMutation<
    PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsDocumentidImport400
      | PostApiV1TutoraiDocumentsDocumentidImport401
      | PostApiV1TutoraiDocumentsDocumentidImport404
      | PostApiV1TutoraiDocumentsDocumentidImport500
    >,
    {
      documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1TutoraiDocumentsDocumentidImportMutationResponse,
    ResponseErrorConfig<
      | PostApiV1TutoraiDocumentsDocumentidImport400
      | PostApiV1TutoraiDocumentsDocumentidImport401
      | PostApiV1TutoraiDocumentsDocumentidImport404
      | PostApiV1TutoraiDocumentsDocumentidImport500
    >,
    {
      documentId: PostApiV1TutoraiDocumentsDocumentidImportPathParams["documentId"];
    },
    TContext
  >;
}
